import isNil from 'lodash/isNil'

export const key = 'legend'

function setEvent(options, chart) {
  if (options.onClick) {
    const { onClick, ...newOptions } = options
    newOptions.onClick = function (event) {
      onClick(event, chart)
    }
    return newOptions
  }
  return options
}

export const process = (chart, config) => {
  const isArr = Array.isArray(config)
  if (isNil(config) || config === false || (isArr && config.length === 0) || config.show === false) {
    return chart.scrollableLegend(false)
  }
  if (config.show) {
    config.nameStyle = {
      fill: config.fill
    } // legend颜色设置
    return chart.scrollableLegend(config)
  }

  const arrLegend = isArr ? config : [config]

  arrLegend.forEach((res) => {
    if (res.dataKey) {
      if (res.show === false) {
        chart.scrollableLegend(res.dataKey, false)
      } else {
        const { show, dataKey, ...options } = res
        chart.scrollableLegend(res.dataKey, setEvent(options, chart))
      }
    } else {
      chart.scrollableLegend(setEvent(res, chart))
    }
  })

  return chart
}
